import form from './form.js';
import { Router } from '@/legacy/Router';

Router.get('tax/:any', form);
